@if (!isLanguageSelected) {
  <div class="info-screen d-flex align-center justify-center">
    <div class="fx-col gap-24 info-card language-picker">
      <div class="fx-col gap-8">
        @for (item of languages; track item.Code) {
          <div class="title" [attr.lang]="item.Code" [attr.dir]="item.Direction">{{item.Prompt}}</div>
        }
      </div>
      <div class="language-selection">
        @for (item of languages; track item.Code; let last = $last) {
          <button class="link"
            [ngClass]="{'selected': item.Code === selectedLang}"
            (click)="selectLanguage(item.Code)">{{item.Name}}</button>
          @if (!last) {
            <div class="divider"></div>
          }
        }
      </div>
    </div>
  </div>
} @else {
  @if (!isLinkExpired && isOtpScreen) {
    <div class="verify-otp">
      <div class="page-wrapper">
        <div class="bg-image">
          <img src="assets/img/otp-screen-bg.png" class="bg" />
          <img src="assets/img/otp-screen-bg-sm.png" class="bg-sm" />
          <img src="assets/img/addenda-logo.png" class="logo" />
        </div>
        <div class="verify-otp-wrapper">
          <div class="language-selection language-switch">
            @for (item of languages; track item.Code; let last = $last) {
              <button class="link"
                [ngClass]="{'selected': item.Code === selectedLang}"
                (click)="onLangChange(item.Code)">{{item.Name}}</button>
              @if (!last) {
                <div class="divider"></div>
              }
            }
          </div>
          <div class="content-wrapper">
            <div class="center-wrapper">
              <div class="btn-back">
                <label class="header-title" for="otp-input">{{"enter_otp_code" | translate }}</label>
              </div>
              <div class="wrapper">
                <div class="container">
                  <div class="splash-desc" [ngClass]="{'info-label':isScroll === false}">
                    @if (source === 'email') {
                      <label for="otp-input">
                        {{"otp_msg_email" | translate }}
                      </label>
                    }
                    @if (source !== 'email') {
                      <label for="otp-input">
                        {{"otp_msg_phone" | translate }}
                      </label>
                    }
                  </div>
                  @if (selectedEmail) {
                    <div class="number_block">
                      @if (source === 'email') {
                        <label for="otp-email">{{'your_email' | translate }}</label>
                      }
                      @if (source !== 'email') {
                        <label for="otp-phone">{{'your_phone' | translate }}</label>
                      }
                      <div class="number-container">
                        @if (source === 'email') {
                          <span id="otp-email" class="mobile">{{selectedEmail}}</span>
                        }
                        @if (source !== 'email') {
                          <span id="otp-phone" class="mobile">{{selectedPhoneNo}}</span>
                        }
                      </div>
                    </div>
                  }
                  <div class="input_block" [formGroup]="form">
                    <div>
                      <div style="margin-bottom: 8px;">
                        <label class="lable_title" for="otp-input">{{"enter_otp" | translate }}</label>
                      </div>
                      <ng-otp-input id="otp-input" #ngOtpInput (onInputChange)="onOtpChange($event)"
                      [config]="otpConfig"></ng-otp-input>
                      @if (correct_otp ===3) {
                        <div class="wrong_otp">
                          {{errorMessages}}
                        </div>
                      }
                      @if (correct_otp === 2) {
                        <div class="correct_otp">
                          {{'success!' | translate }}
                        </div>
                      }
                    </div>
                  </div>
                  <div class="btn-container">
                    <button mat-button mat-raised-button (click)="verifyOtp();">
                      {{'continue' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            @if (correct_otp !== 2) {
              <div class="bottom_text">
                {{ 'otp_counter' | translate: {second: seconds} }} &nbsp;
                @if (resend) {
                  <span class="resend-sms" (click)="resend_otp()"
                  >{{'resend' | translate }}</span>
                  }@if (resend) {
                  <span>&nbsp;({{resendCounter}})</span>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (isLinkExpired) {
    <div class="info-screen link-expired d-flex align-center justify-center">
      <div class="fx-col gap-24 info-card link-expired-content">
        <div class="icon-wrapper">
          <mat-icon svgIcon="timer-alert-outline"></mat-icon>
        </div>
        <div class="fx-col gap-8">
          <div class="title">{{'sorry' | translate }}!</div>
          <div class="description">{{'link_expired' | translate }}</div>
        </div>
      </div>
    </div>
  }
}
